import React from 'react';

import Spinner from '@provider-portal/common/components/Spinner/Spinner';

import { NetworkRequestState } from '@bolteu/redux-session';

import GenericError, { GenericErrorType } from '../GenericError/GenericError';

export interface RequestStateViewProps {
  children: React.ReactNode;
  isEmpty: boolean;
  requestState: NetworkRequestState;
  intlIdError: string;
  intlIdEmpty: string;
  intlErrorParams?: { [key: string]: string };
  EmptyComponent?: () => React.ReactElement;
}

const RequestStateView: React.FC<RequestStateViewProps> = ({
  children,
  isEmpty,
  intlIdError,
  intlIdEmpty,
  requestState,
  intlErrorParams,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  EmptyComponent = () => <GenericError type={GenericErrorType.info} intlIdTitle={intlIdEmpty} />,
}) => {
  switch (requestState) {
    case NetworkRequestState.waiting:
      return <Spinner />;
    case NetworkRequestState.success:
      return isEmpty ? <EmptyComponent /> : <>{children}</>;
    case NetworkRequestState.failure:
      return (
        <GenericError
          type={GenericErrorType.error}
          intlIdTitle={intlIdError}
          intlProps={intlErrorParams}
        />
      );
    default:
      return <>{children}</>;
  }
};

export default RequestStateView;
